/* NOTE: lodash snakeCase would remove trailing spaces */
export const snakeCase = (value: string) =>
  value.replace(/ /g, "_").replace(/\W/g, "").toLowerCase();
